import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useRef, useEffect } from 'react';
import Fuse from 'fuse.js';
import { useDebounce, useDebouncedCallback } from 'use-debounce';
import { ChannelLineupContainer, FilterContainer, FilterControl, Filter, IconContainer, SearchIcon, CancelIcon, TableWrapper } from './ChannelLineup.styles.js';
import Table from './Table.js';
import chunkArray from '../../utils/chunkArray.js';

var ChannelLineup = function ChannelLineup(_ref) {
  var _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    userFilter = _useState2[0],
    setUserFilter = _useState2[1];
  var _useDebounce = useDebounce(userFilter, 300),
    _useDebounce2 = _slicedToArray(_useDebounce, 1),
    debouncedUserFilter = _useDebounce2[0];
  var tableRef = useRef();
  var channels = data.channels,
    packages = data.packages;
  var updateFilter = function updateFilter(e) {
    setUserFilter(e.target.value);
  };
  var channelArray = channels.edges;

  // TODO: clean up fuse fuzzy filtering - investigate fuse options
  // there are multiple options such as threshold that we weren't
  // sure how to use properly, yet.
  var fuse = new Fuse(channelArray, {
    shouldSort: true,
    keys: ['node.name']
  });
  var fuseResults = fuse.search(debouncedUserFilter);

  // Take the data and break it into chunks so that we can load it more efficiently
  var chunks = chunkArray(channelArray, 20);
  var _useState3 = useState(chunks[0]),
    _useState4 = _slicedToArray(_useState3, 2),
    loadedChunk = _useState4[0],
    setLoadedChunk = _useState4[1];
  var _useState5 = useState(1),
    _useState6 = _slicedToArray(_useState5, 2),
    chunkIndex = _useState6[0],
    setChunkIndex = _useState6[1];
  var handleScroll = function handleScroll() {
    if (tableRef.current && tableRef.current.scrollHeight - tableRef.current.scrollTop - 200 <= tableRef.current.clientHeight) {
      if (chunkIndex <= chunks.length - 1) {
        setChunkIndex(function (prevChunkIndex) {
          return prevChunkIndex + 1;
        });
        setLoadedChunk(function (prevLoadedChunks) {
          return [].concat(_toConsumableArray(prevLoadedChunks), _toConsumableArray(chunks[chunkIndex]));
        });
      }
    }
  };
  var debouncedHandleScroll = useDebouncedCallback(handleScroll, 5);
  useEffect(function () {
    var tableElement = tableRef.current;
    if (tableElement) {
      tableElement.addEventListener('scroll', debouncedHandleScroll);
    }
    return function () {
      if (tableElement) {
        tableElement.removeEventListener('scroll', debouncedHandleScroll);
      }
    };
  }, [debouncedHandleScroll]);
  return /*#__PURE__*/React__default.createElement(ChannelLineupContainer, {
    className: "leshen-channel-lineup"
  }, /*#__PURE__*/React__default.createElement(FilterContainer, {
    className: "filter-container"
  }, /*#__PURE__*/React__default.createElement(FilterControl, {
    className: "filter-control"
  }, /*#__PURE__*/React__default.createElement(Filter, {
    "data-testid": "ChannelLineup-input",
    placeholder: "Search",
    type: "text",
    value: userFilter,
    onChange: updateFilter,
    className: "filter"
  }), /*#__PURE__*/React__default.createElement(IconContainer, {
    direction: "left",
    className: "icon-container"
  }, /*#__PURE__*/React__default.createElement(SearchIcon, {
    size: "1.5em",
    className: "search-icon"
  })), userFilter !== '' && /*#__PURE__*/React__default.createElement(IconContainer, {
    direction: "right",
    "data-testid": "ChannelLineup-cancel",
    onClick: function onClick() {
      return setUserFilter('');
    },
    onKeyDown: function onKeyDown(e) {
      return e.keyCode === 13 && setUserFilter('');
    },
    tabIndex: "0"
  }, /*#__PURE__*/React__default.createElement(CancelIcon, {
    size: "1.5em",
    className: "cancel-icon"
  })))), /*#__PURE__*/React__default.createElement(TableWrapper, {
    className: "table-wrapper",
    ref: tableRef
  }, /*#__PURE__*/React__default.createElement(Table, {
    className: "table",
    channels: fuseResults.length > 0 ? fuseResults : loadedChunk,
    packages: packages.edges
  })));
};
var ChannelLineup$1 = ChannelLineup;

export { ChannelLineup$1 as default };
//# sourceMappingURL=index.js.map
